(function (window, document) {
  'use strict';

  var P = window.Printara;
  if (!P) return;

  function initCalc(calcRoot) {
    if (!calcRoot || calcRoot.dataset.gkReady === 'true') return;
    calcRoot.dataset.gkReady = 'true';

    var key = calcRoot.dataset.gkKey;

    var byId = function (base) {
      return document.getElementById(base + '-' + key);
    };

    var $ = function (selector, root) {
      return (root || calcRoot).querySelector(selector);
    };

    var $$ = function (selector, root) {
      return Array.prototype.slice.call(
        (root || calcRoot).querySelectorAll(selector)
      );
    };

    var currentSquareFootage = 0;
    var currentPanelPlan = null;
    var panelingRequired = false;
    var panelOrientationAuto = true;
    var panelMediaWidthAuto = true;

    var widthInput = byId('gk-width');
    var heightInput = byId('gk-height');
    var sqftInput = byId('gk-sqft');
    var mediaWidthSelect = byId('gk-mediaWidth');
    var outputEl = byId('gk-output');
    var vinylMsgEl = byId('gk-vinylLengthMessage');
    var resultCardEl = byId('gk-result-card');
    var resultSqftEl = byId('gk-result-sqft');
    var resultMediaEl = byId('gk-result-media');
    var resultMaxAreaEl = byId('gk-result-max-area');
    var resultNoteEl = byId('gk-result-note');
    var hiddenSqft = byId('gk-prop-sqft');
    var hiddenMedia = byId('gk-prop-media');
    var hiddenDimensions = byId('gk-prop-dimensions');
    var panelingEl = byId('gk-paneling');
    var panelControlsEl = byId('gk-panel-controls');
    var panelMediaWidthSelect = byId('gk-panel-media-width-select');
    var panelOrientationSelect = byId('gk-panel-orientation');
    var panelEqualInput = byId('gk-panel-equal');
    var panelSummaryEl = byId('gk-panel-summary');
    var panelProjectEl = byId('gk-panel-project');
    var panelDirectionEl = byId('gk-panel-direction');
    var panelMediaEl = byId('gk-panel-media');
    var panelOverlapSummaryEl = byId('gk-panel-overlap-summary');
    var panelCountEl = byId('gk-panel-count');
    var panelSizeEl = byId('gk-panel-size');
    var panelLastLabelEl = byId('gk-panel-last-label');
    var panelLastEl = byId('gk-panel-last');
    var panelSqftEl = byId('gk-panel-sqft');

    function getForm() {
      return P.forms.first(calcRoot);
    }

    function setProperty(name, value, options) {
      var forms = P.forms.all();

      if (!forms.length) {
        var fallback = getForm();
        if (fallback) forms = [fallback];
      }

      forms.forEach(function (form) {
        P.forms.setProperty(form, name, value, options || {});
      });
    }

    function getQtyInput() {
      var form = getForm();

      if (form) {
        // Includes quantity inputs linked with form="product-form-ID".
        if (form.elements && form.elements.namedItem) {
          var associatedQuantity = form.elements.namedItem('quantity');

          if (associatedQuantity) {
            if (
              typeof associatedQuantity.length === 'number' &&
              !associatedQuantity.nodeType
            ) {
              if (associatedQuantity.length) {
                return associatedQuantity[0];
              }
            } else {
              return associatedQuantity;
            }
          }
        }

        var inForm =
          form.querySelector('input[name="quantity"]') ||
          form.querySelector('.quantity__input');

        if (inForm) return inForm;

        var quantityControls = document.querySelectorAll(
          'input[name="quantity"], input.quantity__input'
        );

        for (var i = 0; i < quantityControls.length; i += 1) {
          if (quantityControls[i].form === form) {
            return quantityControls[i];
          }
        }
      }

      return (
        document.querySelector('input[name="quantity"]') ||
        document.querySelector('.quantity__input')
      );
    }

    function setQuantity(squareFootage) {
      var qty = getQtyInput();
      var value =
        squareFootage && squareFootage > 0
          ? String(Math.floor(squareFootage))
          : '';

      if (!qty || qty.value === value) return;

      qty.value = value;
      qty.dispatchEvent(new Event('input', { bubbles: true }));
      qty.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function getMediaSizes() {
      return P.media ? P.media.getWidths() : [];
    }

    function getMediaLength() {
      return P.media ? P.media.getLength() : null;
    }

    function isContourCutSelected() {
      return !!(
        P.productionOptions &&
        P.productionOptions.isContourCutSelected()
      );
    }

    function getUsableMediaWidth(mediaWidth) {
      var width = Number(mediaWidth);

      if (!isFinite(width) || width <= 0) return 0;

      // Contour cutting reserves 2 inches total across the roll.
      // This replaces the standard 0.5-inch allowance.
      if (isContourCutSelected()) {
        return Math.max(0, width - 2);
      }

      return P.productionOptions
        ? P.productionOptions.getUsableMediaWidth(width)
        : Math.max(0, width - 0.5);
    }

    function getCopyState() {
      return P.copies
        ? P.copies.getState(calcRoot)
        : {
            mode: getActiveTabId(),
            copyMode: 'single',
            copies: 1
          };
    }

    function setCopiesProperty(copies) {
      var value = String(Math.max(1, parseInt(copies, 10) || 1));
      var hidden = calcRoot.querySelector('[data-gk-copies-property]');

      if (hidden) hidden.value = value;

      P.forms.all().forEach(function (form) {
        P.forms.setProperty(form, 'Copies', value, {
          marker: 'copies',
          disableWhenEmpty: false
        });
      });
    }

    function addContourNote(note) {
      if (!isContourCutSelected()) return note || '';

      var contourNote =
        'Contour Cut selected: maximum artwork width is 2″ less ' +
        'than the media width. Paneling is unavailable.';

      return note ? note + ' ' + contourNote : contourNote;
    }

    function billedCopySquareFeet(rawSquareFeet, mediaWidth) {
      return Math.max(
        Math.ceil(rawSquareFeet),
        Math.ceil(mediaWidth / 12)
      );
    }

    function buildCopyCandidate(
      across,
      down,
      mediaWidth,
      quantity,
      mediaLength
    ) {
      var copiesAcross = P.copies
        ? P.copies.getCopiesAcross(across, mediaWidth)
        : 0;

      // Enforce the contour allowance for single copies and nesting,
      // even if the copies module uses the standard allowance.
      if (isContourCutSelected()) {
        var contourSpacing = P.copies
          ? P.copies.COPY_SPACING
          : 0.25;

        copiesAcross = Math.floor(
          (getUsableMediaWidth(mediaWidth) + contourSpacing) /
          (across + contourSpacing)
        );
      }

      if (!(across > 0) || !(down > 0) || copiesAcross < 1) {
        return null;
      }

      var rows = Math.ceil(quantity / copiesAcross);
      var spacing = P.copies ? P.copies.COPY_SPACING : 0.25;

      var maxRowsPerRoll = mediaLength
        ? Math.floor((mediaLength + spacing) / (down + spacing))
        : rows;

      // Each individual copy must fit on a roll.
      // Additional rows can continue onto new rolls.
      if (maxRowsPerRoll < 1) return null;

      var rollCount = Math.ceil(rows / maxRowsPerRoll);
      var spacingGaps = Math.max(0, rows - rollCount);
      var totalLinearInches =
        rows * down + spacingGaps * spacing;

      var rawSquareFeet = (mediaWidth * totalLinearInches) / 144;
      var rowsOnLongestRoll = Math.min(rows, maxRowsPerRoll);

      var longestRollInches =
        rowsOnLongestRoll * down +
        Math.max(0, rowsOnLongestRoll - 1) * spacing;

      return {
        mediaWidth: mediaWidth,
        usableMediaWidth: getUsableMediaWidth(mediaWidth),
        across: across,
        down: down,
        copiesAcross: copiesAcross,
        rows: rows,
        rollCount: rollCount,
        rollLength: longestRollInches,
        totalLinearInches: totalLinearInches,
        rawSquareFeet: rawSquareFeet,
        billedSquareFeet: billedCopySquareFeet(
          rawSquareFeet,
          mediaWidth
        )
      };
    }

    function bestCopyLayout(
      width,
      height,
      mediaSizes,
      quantity,
      mediaLength
    ) {
      var layouts = [];

      mediaSizes.forEach(function (mediaWidth) {
        var normal = buildCopyCandidate(
          width,
          height,
          mediaWidth,
          quantity,
          mediaLength
        );

        if (normal) layouts.push(normal);

        if (width !== height) {
          var rotated = buildCopyCandidate(
            height,
            width,
            mediaWidth,
            quantity,
            mediaLength
          );

          if (rotated) layouts.push(rotated);
        }
      });

      layouts.sort(function (a, b) {
        // Choose the lowest billable material usage first.
        if (a.billedSquareFeet !== b.billedSquareFeet) {
          return a.billedSquareFeet - b.billedSquareFeet;
        }

        // When billed usage ties, prefer less material waste.
        if (Math.abs(a.rawSquareFeet - b.rawSquareFeet) > 0.0001) {
          return a.rawSquareFeet - b.rawSquareFeet;
        }

        return a.mediaWidth - b.mediaWidth;
      });

      return layouts.length ? layouts[0] : null;
    }

    function maxFillCopies(layout, width, height, mediaLength) {
      if (!layout) return 1;

      var spacing = P.copies ? P.copies.COPY_SPACING : 0.25;
      var usableWidth = getUsableMediaWidth(layout.mediaWidth);

      var billableLength =
        (layout.billedSquareFeet * 144) /
        layout.mediaWidth;

      var availableLength = Math.max(
        layout.rollLength,
        billableLength
      );

      if (mediaLength) {
        availableLength = Math.min(availableLength, mediaLength);
      }

      var orientations = [
        { across: width, down: height },
        { across: height, down: width }
      ];

      var maxCopies = 1;

      orientations.forEach(function (orientation) {
        if (
          orientation.across > usableWidth ||
          orientation.down > availableLength
        ) {
          return;
        }

        var columns = Math.floor(
          (usableWidth + spacing) /
          (orientation.across + spacing)
        );

        var rows = Math.floor(
          (availableLength + spacing) /
          (orientation.down + spacing)
        );

        maxCopies = Math.max(maxCopies, columns * rows);
      });

      return maxCopies;
    }

    function setOutput(text) {
      if (!outputEl) return;

      outputEl.textContent = text || '';
      outputEl.classList.toggle('is-visible', !!text);
    }

    function setVinylMsg(text) {
      if (!vinylMsgEl) return;

      vinylMsgEl.textContent = text || '';
      vinylMsgEl.classList.toggle('is-visible', !!text);
    }

    function hideResultCard() {
      if (resultCardEl) {
        resultCardEl.classList.remove('is-visible');
      }

      if (resultSqftEl) resultSqftEl.textContent = '—';
      if (resultMediaEl) resultMediaEl.textContent = '—';

      if (resultMaxAreaEl) {
        resultMaxAreaEl.textContent = 'Maximum print area: —';
      }

      if (resultNoteEl) {
        resultNoteEl.textContent = '';
        resultNoteEl.classList.remove('is-visible');
      }
    }

    function showResultCard(squareFootage, mediaWidth, note) {
      var sqftValue = Number(squareFootage);
      var mediaValue = Number(mediaWidth);

      if (!sqftValue || !mediaValue) {
        hideResultCard();
        return;
      }

      if (resultSqftEl) {
        resultSqftEl.textContent = P.util.formatNumber(sqftValue, 2);
      }

      if (resultMediaEl) {
        resultMediaEl.textContent =
          P.util.formatNumber(mediaValue, 2) + '″';
      }

      if (resultMaxAreaEl) {
        var printableWidth = getUsableMediaWidth(mediaValue);
        var mediaLength = getMediaLength();

        resultMaxAreaEl.textContent =
          printableWidth > 0 && mediaLength
            ? 'Maximum print area: ' +
              P.util.formatNumber(printableWidth) + '″ × ' +
              P.util.formatNumber(mediaLength) + '″'
            : 'Maximum print area: —';
      }

      if (resultCardEl) {
        resultCardEl.classList.add('is-visible');
      }

      if (resultNoteEl) {
        resultNoteEl.textContent = addContourNote(note || '');
        resultNoteEl.classList.toggle(
          'is-visible',
          !!resultNoteEl.textContent
        );
      }
    }

    function getUnitPrice() {
      var data = P.product.getData() || {};
      var variantId = P.product.getVariantId();
      var variantKey = String(variantId || '');
      var prices = data.variantPrices || {};

      var cents =
        variantId && prices[variantKey] != null
          ? Number(prices[variantKey])
          : null;

      if (cents == null || isNaN(cents)) {
        var selectors = [
          '.price-item--sale',
          '.price-item--regular',
          '.price .money',
          '.price__regular',
          '[data-product-price]'
        ];

        for (var i = 0; i < selectors.length; i += 1) {
          var el = document.querySelector(selectors[i]);
          if (!el) continue;

          var parsed = P.util.parseMoneyText(el.textContent || '');
          if (parsed) return parsed;
        }

        return null;
      }

      var unitPriceCents = cents;

      if (data.isB2BCustomer) {
        var quantityInput = getQtyInput();

        var quantity = quantityInput
          ? P.util.parseNumber(quantityInput.value)
          : 0;

        if (!(quantity > 0)) {
          quantity = currentSquareFootage;
        }

        var breaksByVariant = data.variantPriceBreaks || {};
        var priceBreaks = breaksByVariant[variantKey] || [];
        var highestMinimum = 0;

        priceBreaks.forEach(function (priceBreak) {
          var minimum = Number(priceBreak.minimumQuantity);
          var breakPrice = Number(priceBreak.price);

          if (
            quantity >= minimum &&
            minimum >= highestMinimum &&
            !isNaN(breakPrice)
          ) {
            highestMinimum = minimum;
            unitPriceCents = breakPrice;
          }
        });
      }

      return {
        amount: unitPriceCents / 100,
        currencyPrefix: getCurrencyPrefixFromTheme()
      };
    }

    function getCurrencyPrefixFromTheme() {
      var selectors = [
        '.price-item--sale',
        '.price-item--regular',
        '.price .money',
        '.price__regular',
        '[data-product-price]'
      ];

      for (var i = 0; i < selectors.length; i += 1) {
        var el = document.querySelector(selectors[i]);
        if (!el) continue;

        var parsed = P.util.parseMoneyText(el.textContent || '');

        if (parsed && parsed.currencyPrefix) {
          return parsed.currencyPrefix;
        }
      }

      return '$';
    }

    function setTotalPrice(squareFootage) {
      var totalEl = document.getElementById('totalPrice');
      if (!totalEl) return;

      var unit = getUnitPrice();

      if (!unit || !squareFootage) {
        totalEl.textContent =
          (unit ? unit.currencyPrefix : '$') + '0.00';
        return;
      }

      totalEl.textContent =
        unit.currencyPrefix +
        (unit.amount * squareFootage).toFixed(2);
    }

    function roundToNearestQuarter(value) {
      return Math.round(value * 4) / 4;
    }

    function getActiveTabId() {
      var active = $('.gk-tab.is-active');
      return active ? active.getAttribute('data-tab') : 'dimensions';
    }

    function setDimensionsProperty(width, height) {
      var value =
        width && height
          ? P.util.formatNumber(width) + '″ × ' +
            P.util.formatNumber(height) + '″'
          : '';

      if (hiddenDimensions) {
        hiddenDimensions.value = value;
        hiddenDimensions.disabled = !value;
      }

      P.forms.all().forEach(function (form) {
        P.forms.setProperty(form, 'Dimensions', value, {
          marker: 'dimensions',
          disableWhenEmpty: true
        });
      });
    }

    function setSquareFeetAndMedia(squareFeet, mediaWidth) {
      var sqftValue = squareFeet ? String(squareFeet) : '';
      var mediaValue = mediaWidth ? String(mediaWidth) + 'in' : '';

      if (hiddenSqft) hiddenSqft.value = sqftValue;
      if (hiddenMedia) hiddenMedia.value = mediaValue;

      setProperty('Square Feet', sqftValue);
      setProperty('Media Width', mediaValue);
    }

    function clearPanelProperties() {
      [
        'Panel Project',
        'Panel Orientation',
        'Panel Count',
        'Panel Overlap',
        'Panel Sizing',
        'Panel Media Width',
        'Panel Length',
        'Approx. Printed Panel Size',
        'Last Panel Coverage'
      ].forEach(function (name) {
        setProperty(name, '');
      });
    }

    function hidePaneling() {
      panelingRequired = false;
      currentPanelPlan = null;

      if (panelingEl) {
        panelingEl.classList.remove('is-visible');
      }

      if (panelControlsEl) {
        panelControlsEl.classList.remove('is-hidden');
        panelControlsEl.hidden = false;
      }

      if (panelSummaryEl) {
        panelSummaryEl.classList.remove('is-visible');
      }

      clearPanelProperties();
    }

    function buildPanelCandidate(
      projectWidth,
      projectHeight,
      mediaWidth,
      mediaLength,
      overlap,
      orientation,
      equalPanels,
      projectCopies
    ) {
      // Contour-cut jobs must never generate a panel plan.
      if (isContourCutSelected()) return null;

      var printableWidth = getUsableMediaWidth(mediaWidth);

      var span =
        orientation === 'vertical'
          ? projectWidth
          : projectHeight;

      var panelLength =
        orientation === 'vertical'
          ? projectHeight
          : projectWidth;

      var effectiveCoverage = printableWidth - overlap;

      if (
        !printableWidth ||
        printableWidth <= 0 ||
        !effectiveCoverage ||
        effectiveCoverage <= 0 ||
        panelLength > mediaLength
      ) {
        return null;
      }

      var panelCount =
        span <= printableWidth
          ? 1
          : 1 + Math.ceil(
              (span - printableWidth) / effectiveCoverage
            );

      var equalPanelWidth =
        (span + overlap * (panelCount - 1)) / panelCount;

      if (equalPanels && equalPanelWidth > printableWidth) {
        return null;
      }

      var printedPanelWidth =
        equalPanels ? equalPanelWidth : printableWidth;

      var rawSquareFeet =
        (
          mediaWidth *
          panelLength *
          panelCount *
          Math.max(1, projectCopies || 1)
        ) / 144;

      var billedSquareFeet = Math.ceil(rawSquareFeet);

      var lastPanelCoverage = equalPanels
        ? equalPanelWidth
        : span - effectiveCoverage * (panelCount - 1);

      if (lastPanelCoverage <= 0) {
        lastPanelCoverage = printedPanelWidth;
      }

      return {
        orientation: orientation,
        mediaWidth: mediaWidth,
        printableWidth: printableWidth,
        printedPanelWidth: printedPanelWidth,
        equalPanels: equalPanels,
        overlap: overlap,
        panelCount: panelCount,
        panelLength: panelLength,
        span: span,
        rawSquareFeet: rawSquareFeet,
        billedSquareFeet: billedSquareFeet,
        projectCopies: Math.max(1, projectCopies || 1),
        lastPanelCoverage: Math.min(
          lastPanelCoverage,
          printedPanelWidth
        )
      };
    }

    function comparePanelCandidates(a, b) {
      // Start with the narrowest supplied roll supporting the plan.
      if (a.mediaWidth !== b.mediaWidth) {
        return a.mediaWidth - b.mediaWidth;
      }

      if (a.billedSquareFeet !== b.billedSquareFeet) {
        return a.billedSquareFeet - b.billedSquareFeet;
      }

      if (Math.abs(a.rawSquareFeet - b.rawSquareFeet) > 0.0001) {
        return a.rawSquareFeet - b.rawSquareFeet;
      }

      return a.panelCount - b.panelCount;
    }

    function findBestPanelPlan(
      projectWidth,
      projectHeight,
      mediaLength,
      mediaSizes,
      projectCopies
    ) {
      var overlap = 1;
      var equalPanels = !panelEqualInput || panelEqualInput.checked;

      var automaticOrientation =
        projectWidth >= projectHeight ? 'vertical' : 'horizontal';

      var selectedOrientation = panelOrientationAuto
        ? automaticOrientation
        : panelOrientationSelect
          ? panelOrientationSelect.value
          : automaticOrientation;

      if (
        selectedOrientation !== 'vertical' &&
        selectedOrientation !== 'horizontal'
      ) {
        selectedOrientation = automaticOrientation;
      }

      var allowedMediaSizes = mediaSizes.slice();

      if (!panelMediaWidthAuto && panelMediaWidthSelect) {
        var requestedMediaWidth = parseFloat(
          panelMediaWidthSelect.value
        );

        if (!isNaN(requestedMediaWidth)) {
          allowedMediaSizes = mediaSizes.filter(function (mediaWidth) {
            return Math.abs(
              mediaWidth - requestedMediaWidth
            ) < 0.0001;
          });
        }
      }

      var candidates = [];

      allowedMediaSizes.forEach(function (mediaWidth) {
        var candidate = buildPanelCandidate(
          projectWidth,
          projectHeight,
          mediaWidth,
          mediaLength,
          overlap,
          selectedOrientation,
          equalPanels,
          projectCopies
        );

        if (candidate && candidate.panelCount > 1) {
          candidates.push(candidate);
        }
      });

      candidates.sort(comparePanelCandidates);

      var best = candidates.length ? candidates[0] : null;

      if (best) {
        if (panelOrientationAuto && panelOrientationSelect) {
          panelOrientationSelect.value = best.orientation;
        }

        if (panelMediaWidthAuto && panelMediaWidthSelect) {
          panelMediaWidthSelect.value = String(best.mediaWidth);
        }
      }

      return best;
    }

    function showPanelPlan(plan, projectWidth, projectHeight) {
      currentPanelPlan = plan;
      panelingRequired = true;

      if (panelingEl) {
        panelingEl.classList.add('is-visible');
      }

      if (!plan) {
        if (panelSummaryEl) {
          panelSummaryEl.classList.remove('is-visible');
        }

        currentSquareFootage = 0;
        setQuantity(0);
        setTotalPrice(0);
        setSquareFeetAndMedia('', '');
        clearPanelProperties();

        setOutput(
          'No valid panel layout is available with the selected media width, ' +
          'orientation, fixed 1″ overlap, and media length.'
        );

        hideResultCard();
        updateSubmitButtonState();
        emitCalculatorUpdate();
        return;
      }

      if (panelSummaryEl) {
        panelSummaryEl.classList.add('is-visible');
      }

      if (panelProjectEl) {
        panelProjectEl.textContent =
          P.util.formatNumber(projectWidth) + '″ × ' +
          P.util.formatNumber(projectHeight) + '″';
      }

      if (panelDirectionEl) {
        panelDirectionEl.textContent =
          plan.orientation === 'vertical'
            ? 'Vertical panels'
            : 'Horizontal panels';
      }

      if (panelMediaEl) {
        panelMediaEl.textContent =
          P.util.formatNumber(plan.mediaWidth) + '″';
      }

      if (panelOverlapSummaryEl) {
        panelOverlapSummaryEl.textContent =
          P.util.formatNumber(plan.overlap) + '″';
      }

      if (panelCountEl) {
        panelCountEl.textContent = String(plan.panelCount);
      }

      if (panelSizeEl) {
        panelSizeEl.textContent =
          P.util.formatNumber(plan.printedPanelWidth) + '″ × ' +
          P.util.formatNumber(plan.panelLength) + '″';
      }

      if (panelLastLabelEl) {
        panelLastLabelEl.hidden = plan.equalPanels;
      }

      if (panelLastEl) {
        panelLastEl.hidden = plan.equalPanels;
        panelLastEl.textContent =
          plan.equalPanels
            ? ''
            : P.util.formatNumber(plan.lastPanelCoverage) + '″';
      }

      if (panelSqftEl) {
        panelSqftEl.textContent =
          String(plan.billedSquareFeet) + ' sq ft';
      }

      currentSquareFootage = plan.billedSquareFeet;
      setQuantity(plan.billedSquareFeet);
      setTotalPrice(plan.billedSquareFeet);
      setSquareFeetAndMedia(
        plan.billedSquareFeet,
        plan.mediaWidth
      );

      setProperty('Panel Project', 'Yes');

      setProperty(
        'Panel Orientation',
        plan.orientation === 'vertical' ? 'Vertical' : 'Horizontal'
      );

      setProperty('Panel Count', String(plan.panelCount));
      setProperty(
        'Panel Overlap',
        P.util.formatNumber(plan.overlap) + 'in'
      );

      setProperty(
        'Panel Sizing',
        plan.equalPanels
          ? 'Equal panel widths'
          : 'Full-width panels with reduced final panel'
      );

      setProperty(
        'Panel Media Width',
        P.util.formatNumber(plan.mediaWidth) + 'in'
      );

      setProperty(
        'Panel Length',
        P.util.formatNumber(plan.panelLength) + 'in'
      );

      setProperty(
        'Approx. Printed Panel Size',
        P.util.formatNumber(plan.printedPanelWidth) + 'in × ' +
        P.util.formatNumber(plan.panelLength) + 'in'
      );

      setProperty(
        'Last Panel Coverage',
        P.util.formatNumber(plan.lastPanelCoverage) + 'in'
      );

      setCopiesProperty(1);
      setOutput('');
      setVinylMsg('');
      showResultCard(plan.billedSquareFeet, plan.mediaWidth, '');

      updateSubmitButtonState();
      emitCalculatorUpdate();
    }

    function clearAll() {
      if (widthInput) widthInput.value = '';
      if (heightInput) heightInput.value = '';
      if (sqftInput) sqftInput.value = '';
      if (mediaWidthSelect) mediaWidthSelect.selectedIndex = 0;

      setOutput('');
      setVinylMsg('');
      hideResultCard();

      currentSquareFootage = 0;
      currentPanelPlan = null;
      panelingRequired = false;
      panelOrientationAuto = true;
      panelMediaWidthAuto = true;

      setQuantity(0);
      setTotalPrice(0);
      hidePaneling();
      setSquareFeetAndMedia('', '');
      setDimensionsProperty('', '');

      updateSubmitButtonState();
      emitCalculatorUpdate();
    }

    function rejectContourOrder(message) {
      hidePaneling();
      hideResultCard();

      currentSquareFootage = 0;
      setQuantity(0);
      setTotalPrice(0);
      setSquareFeetAndMedia('', '');
      setCopiesProperty(1);
      setVinylMsg('');

      if (P.copies && P.copies.setFillAvailability) {
        P.copies.setFillAvailability(calcRoot, {
          maxCopies: 0,
          squareFeet: 0,
          panelingRequired: false
        });
      }

      setOutput(message);
      updateSubmitButtonState();
      emitCalculatorUpdate();
    }

    function contourDimensionsFit() {
      if (getActiveTabId() !== 'dimensions') return false;

      var width = parseFloat(widthInput && widthInput.value);
      var height = parseFloat(heightInput && heightInput.value);
      var length = Number(getMediaLength());

      if (!(width > 0) || !(height > 0) || !(length > 0)) {
        return false;
      }

      return getMediaSizes().some(function (mediaWidth) {
        var usableWidth = Math.max(0, Number(mediaWidth) - 2);

        return (
          (width <= usableWidth && height <= length) ||
          (height <= usableWidth && width <= length)
        );
      });
    }

    function updateSubmitButtonState() {
      var active = getActiveTabId();
      var terms = document.getElementById('termsCheckbox');
      var termsChecked = terms ? terms.checked : false;

      var scaleSection = document.getElementById('scale');
      var scaleSelect = document.getElementById('scale-select');
      var scaleValid = true;

      if (scaleSection && !scaleSection.hidden && scaleSelect) {
        scaleValid = scaleSelect.value !== '';
      }

      var hasDimensions = !!(
        widthInput &&
        widthInput.value &&
        heightInput &&
        heightInput.value
      );

      var hasSquareFootage = !!(
        sqftInput &&
        sqftInput.value &&
        mediaWidthSelect &&
        mediaWidthSelect.value
      );

      var ok = false;

      if (active === 'dimensions') {
        var panelingValid =
          !panelingRequired ||
          (currentPanelPlan && currentSquareFootage > 0);

        ok =
          hasDimensions &&
          termsChecked &&
          scaleValid &&
          panelingValid;
      } else {
        ok = hasSquareFootage && termsChecked && scaleValid;
      }

      // A failed calculation must not leave Add to Cart enabled.
      ok = !!(ok && currentSquareFootage > 0);

      if (isContourCutSelected()) {
        ok =
          ok &&
          !currentPanelPlan &&
          contourDimensionsFit();
      }

      var btn = document.querySelector('.product-form__submit');
      if (btn) btn.disabled = !ok;

      return ok;
    }

    function calculateFromDimensions() {
      if (getActiveTabId() !== 'dimensions') return;

      var width = parseFloat(widthInput && widthInput.value);
      var height = parseFloat(heightInput && heightInput.value);
      var mediaLength = getMediaLength();
      var mediaSizes = getMediaSizes();

      setDimensionsProperty(width, height);

      if (
        !(width > 0) ||
        !(height > 0) ||
        !isFinite(width) ||
        !isFinite(height) ||
        !mediaLength ||
        !mediaSizes.length
      ) {
        setOutput('');
        setVinylMsg('');
        hideResultCard();
        hidePaneling();

        if (P.copies) {
          if (P.copies.setCopiesAvailability) {
            P.copies.setCopiesAvailability(calcRoot, {
              panelingRequired: false
            });
          }

          P.copies.setFillAvailability(calcRoot, {
            maxCopies: 0,
            squareFeet: 0,
            panelingRequired: false
          });
        }

        currentSquareFootage = 0;
        setTotalPrice(0);
        setQuantity(0);
        setSquareFeetAndMedia('', '');
        setCopiesProperty(1);

        updateSubmitButtonState();
        emitCalculatorUpdate();
        return;
      }

      // Try all available media widths and both orientations first.
      var singleLayout = bestCopyLayout(
        width,
        height,
        mediaSizes,
        1,
        mediaLength
      );

      if (singleLayout) {
        hidePaneling();

        if (P.copies && P.copies.setCopiesAvailability) {
          P.copies.setCopiesAvailability(calcRoot, {
            panelingRequired: false
          });
        }

        var fillCopies = maxFillCopies(
          singleLayout,
          width,
          height,
          mediaLength
        );

        if (P.copies) {
          P.copies.setFillAvailability(calcRoot, {
            maxCopies: fillCopies,
            squareFeet: singleLayout.billedSquareFeet,
            panelingRequired: false
          });
        }

        var copyState = getCopyState();
        var layout = singleLayout;
        var copies = 1;

        if (copyState.copyMode === 'quantity') {
          copies = copyState.copies;

          layout = bestCopyLayout(
            width,
            height,
            mediaSizes,
            copies,
            mediaLength
          );

          if (!layout) {
            currentSquareFootage = 0;
            setQuantity(0);
            setTotalPrice(0);
            setSquareFeetAndMedia('', '');
            setCopiesProperty(copies);
            hideResultCard();

            setOutput(
              'The selected copy quantity exceeds the available media length. ' +
              'Reduce the number of copies or contact us for assistance.'
            );

            updateSubmitButtonState();
            emitCalculatorUpdate();
            return;
          }
        } else if (copyState.copyMode === 'fill') {
          copies = copyState.copies;
        }

        if (mediaWidthSelect) {
          mediaWidthSelect.value = layout.mediaWidth + 'in';
        }

        currentSquareFootage = layout.billedSquareFeet;
        setQuantity(layout.billedSquareFeet);
        setTotalPrice(layout.billedSquareFeet);

        setSquareFeetAndMedia(
          layout.billedSquareFeet,
          layout.mediaWidth
        );

        setCopiesProperty(copies);
        setOutput('');
        setVinylMsg('');

        var note =
          'Material usage is calculated from the media width used and the length ' +
          'required to produce your finished print size.';

        if (copyState.copyMode === 'fill') {
          note +=
            ' ' + copies +
            ' copies fit within the same purchased media amount.';
        } else if (copyState.copyMode === 'quantity' && copies > 1) {
          note +=
            ' The requested ' + copies +
            ' copies are arranged with 0.25″ spacing. ' +
            'Additional rows continue on another roll when needed.';
        }

        showResultCard(
          layout.billedSquareFeet,
          layout.mediaWidth,
          note
        );

        updateSubmitButtonState();
        emitCalculatorUpdate();
        return;
      }

      // No single-piece layout fits. Contour cutting cannot use paneling.
      if (isContourCutSelected()) {
        var maxContourWidth = Math.max.apply(
          null,
          mediaSizes.map(function (size) {
            return Math.max(0, Number(size) - 2);
          })
        );

        rejectContourOrder(
          'Contour-cut artwork must fit on one continuous piece of media. ' +
          'Maximum width across the available media: ' +
          P.util.formatNumber(maxContourWidth) +
          '″ (media width minus 2″). Maximum length: ' +
          P.util.formatNumber(mediaLength) +
          '″. Paneling is unavailable with contour cutting. ' +
          'Reduce your dimensions or select an option without contour cutting.'
        );

        return;
      }

      // Normal printing can still fall back to paneling.
      if (P.copies) {
        if (P.copies.setCopiesAvailability) {
          P.copies.setCopiesAvailability(calcRoot, {
            panelingRequired: true
          });
        }

        P.copies.setFillAvailability(calcRoot, {
          maxCopies: 0,
          squareFeet: 0,
          panelingRequired: true
        });
      }

      panelingRequired = true;

      if (panelingEl) {
        panelingEl.classList.add('is-visible');
      }

      // Paneled projects do not offer Copies.
      // Always calculate one complete paneled project.
      var projectCopies = 1;
      setCopiesProperty(1);

      showPanelPlan(
        findBestPanelPlan(
          width,
          height,
          mediaLength,
          mediaSizes,
          projectCopies
        ),
        width,
        height
      );
    }

    function updateVinylLengthMessage() {
      if (getActiveTabId() !== 'squareFootage') return;

      var sqft = parseFloat(sqftInput && sqftInput.value);
      var mediaWidth = mediaWidthSelect ? mediaWidthSelect.value : '';

      if (!sqft || !mediaWidth) {
        setVinylMsg('');
        updateSubmitButtonState();
        return;
      }

      var mediaWidthFeet =
        parseFloat(mediaWidth.replace('in', '')) / 12;

      var vinylLength = sqft / mediaWidthFeet;
      var rounded = roundToNearestQuarter(vinylLength);

      setVinylMsg(
        'Approximate roll length: ' + rounded.toFixed(2) + ' ft'
      );

      updateSubmitButtonState();
    }

    function submitSquareFootage() {
      if (getActiveTabId() !== 'squareFootage') return;

      // Square footage alone cannot verify a contour-cut width limit.
      if (isContourCutSelected()) {
        setDimensionsProperty('', '');

        rejectContourOrder(
          'Contour-cut orders require artwork dimensions to verify the ' +
          'media width limit. Select the Dimensions tab and enter your ' +
          'finished print size. Paneling is unavailable with contour cutting.'
        );

        return;
      }

      hidePaneling();
      setDimensionsProperty('', '');

      var sqft = parseFloat(sqftInput && sqftInput.value);
      var mediaWidth = mediaWidthSelect ? mediaWidthSelect.value : '';

      if (!sqft || !mediaWidth) {
        currentSquareFootage = 0;
        setQuantity(0);
        setTotalPrice(0);
        setOutput('');
        setVinylMsg('');
        hideResultCard();
        setSquareFeetAndMedia('', '');

        updateSubmitButtonState();
        emitCalculatorUpdate();
        return;
      }

      currentSquareFootage = Math.ceil(sqft);
      setQuantity(currentSquareFootage);
      setTotalPrice(currentSquareFootage);
      setOutput('');

      var squareFootageCopyState = getCopyState();
      setCopiesProperty(squareFootageCopyState.copies);

      showResultCard(
        currentSquareFootage,
        parseFloat(mediaWidth.replace('in', '')),
        'Usage is based on the square footage and media width selected. ' +
        'Copy quantity is informational in Square Footage mode ' +
        'and does not multiply square footage.'
      );

      updateVinylLengthMessage();

      setSquareFeetAndMedia(
        currentSquareFootage,
        parseFloat(mediaWidth.replace('in', ''))
      );

      updateSubmitButtonState();
      emitCalculatorUpdate();
    }

    function setActiveTab(tabId) {
      $$('.gk-tab').forEach(function (button) {
        var active = button.dataset.tab === tabId;

        button.classList.toggle('is-active', active);
        button.setAttribute(
          'aria-selected',
          active ? 'true' : 'false'
        );
      });

      $$('.gk-tabpanel').forEach(function (panel) {
        var active = panel.dataset.tabpanel === tabId;

        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });

      clearAll();

      var dimPanel = calcRoot.querySelector(
        '[data-tabpanel="dimensions"]'
      );

      var sqftPanel = calcRoot.querySelector(
        '[data-tabpanel="squareFootage"]'
      );

      var dimInputs = dimPanel
        ? Array.prototype.slice.call(
            dimPanel.querySelectorAll('input, select')
          )
        : [];

      var sqftInputs = sqftPanel
        ? Array.prototype.slice.call(
            sqftPanel.querySelectorAll('input, select')
          )
        : [];

      dimInputs.forEach(function (element) {
        element.disabled =
          tabId !== 'dimensions' && element.type !== 'hidden';
      });

      sqftInputs.forEach(function (element) {
        element.disabled = tabId !== 'squareFootage';
      });

      if (tabId === 'squareFootage') {
        initMediaSizesDropdown();
        submitSquareFootage();
      }

      updateSubmitButtonState();

      P.emit('printara:calculator:mode', {
        mode: tabId,
        calculator: calcRoot
      });
    }

    function initMediaSizesDropdown(forceFirst) {
      var mediaSizes = getMediaSizes();
      if (!mediaWidthSelect) return;

      var previousValue = mediaWidthSelect.value;
      mediaWidthSelect.innerHTML = '';

      if (!mediaSizes.length) {
        var placeholder = document.createElement('option');
        placeholder.value = '';
        placeholder.textContent = 'No media sizes available';
        mediaWidthSelect.appendChild(placeholder);
        updateSubmitButtonState();
        return;
      }

      mediaSizes.forEach(function (size) {
        var option = document.createElement('option');
        option.value = size + 'in';
        option.textContent = size + '"';
        mediaWidthSelect.appendChild(option);
      });

      var exists =
        !forceFirst &&
        mediaSizes.some(function (size) {
          return previousValue === size + 'in';
        });

      mediaWidthSelect.value =
        exists ? previousValue : mediaSizes[0] + 'in';

      updateSubmitButtonState();
    }

    function initPanelMediaWidthDropdown(forceFirst) {
      if (!panelMediaWidthSelect) return;

      var mediaSizes = getMediaSizes();
      var previousValue = panelMediaWidthSelect.value;

      panelMediaWidthSelect.innerHTML = '';

      if (!mediaSizes.length) {
        var placeholder = document.createElement('option');
        placeholder.value = '';
        placeholder.textContent = 'No media sizes available';
        panelMediaWidthSelect.appendChild(placeholder);
        return;
      }

      mediaSizes.forEach(function (size) {
        var option = document.createElement('option');
        option.value = String(size);
        option.textContent = P.util.formatNumber(size) + '″';
        panelMediaWidthSelect.appendChild(option);
      });

      var exists =
        !forceFirst &&
        mediaSizes.some(function (size) {
          return Math.abs(
            size - parseFloat(previousValue)
          ) < 0.0001;
        });

      panelMediaWidthSelect.value =
        exists ? previousValue : String(mediaSizes[0]);
    }

    function refreshAfterMediaChange(event) {
      var customerMediaChanged = !!(
        event &&
        event.detail &&
        event.detail.customerSupplied
      );

      window.setTimeout(function () {
        panelMediaWidthAuto = true;
        initMediaSizesDropdown(customerMediaChanged);
        initPanelMediaWidthDropdown(customerMediaChanged);

        if (getActiveTabId() === 'dimensions') {
          calculateFromDimensions();
        } else {
          submitSquareFootage();
        }

        setTotalPrice(currentSquareFootage);
        updateSubmitButtonState();
      }, 80);
    }

    function emitCalculatorUpdate() {
      P.emit('printara:calculator:update', {
        mode: getActiveTabId(),
        squareFeet: currentSquareFootage,
        panelingRequired: panelingRequired,
        panelPlan: currentPanelPlan,
        calculator: calcRoot
      });
    }

    $$('.gk-tab').forEach(function (button) {
      button.addEventListener('click', function () {
        setActiveTab(button.dataset.tab);
      });
    });

    if (widthInput) {
      widthInput.addEventListener('input', function () {
        panelOrientationAuto = true;
        panelMediaWidthAuto = true;
        calculateFromDimensions();
      });
    }

    if (heightInput) {
      heightInput.addEventListener('input', function () {
        panelOrientationAuto = true;
        panelMediaWidthAuto = true;
        calculateFromDimensions();
      });
    }

    if (sqftInput) {
      sqftInput.addEventListener('input', submitSquareFootage);
    }

    if (mediaWidthSelect) {
      mediaWidthSelect.addEventListener(
        'change',
        submitSquareFootage
      );
    }

    if (panelMediaWidthSelect) {
      panelMediaWidthSelect.addEventListener('change', function () {
        panelMediaWidthAuto = false;
        calculateFromDimensions();
      });
    }

    if (panelOrientationSelect) {
      panelOrientationSelect.addEventListener('change', function () {
        panelOrientationAuto = false;
        calculateFromDimensions();
      });
    }

    if (panelEqualInput) {
      panelEqualInput.addEventListener(
        'change',
        calculateFromDimensions
      );
    }

    [
      'termsCheckbox',
      'print-instructions',
      'scale-select'
    ].forEach(function (id) {
      var element = document.getElementById(id);

      if (element) {
        element.addEventListener(
          'change',
          updateSubmitButtonState
        );
      }
    });

    document.addEventListener(
      'product:media:update',
      refreshAfterMediaChange
    );

    document.addEventListener(
      'printara:copies:update',
      function (event) {
        if (
          event.detail &&
          event.detail.calculator &&
          event.detail.calculator !== calcRoot
        ) {
          return;
        }

        if (getActiveTabId() === 'dimensions') {
          calculateFromDimensions();
        } else {
          submitSquareFootage();
        }
      }
    );

    document.addEventListener(
      'printara:production-options:update',
      function () {
        panelOrientationAuto = true;
        panelMediaWidthAuto = true;

        if (getActiveTabId() === 'dimensions') {
          calculateFromDimensions();
        } else {
          submitSquareFootage();
        }
      }
    );

    // Revalidate contour-cut jobs before a normal form submission.
    document.addEventListener('submit', function (event) {
      if (!calcRoot.isConnected || !isContourCutSelected()) return;

      var form = event.target;

      if (!form || P.forms.all().indexOf(form) === -1) return;

      if (getActiveTabId() === 'dimensions') {
        calculateFromDimensions();
      } else {
        submitSquareFootage();
      }

      if (!updateSubmitButtonState()) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, true);

    initMediaSizesDropdown(true);
    initPanelMediaWidthDropdown(true);
    setActiveTab('dimensions');

    P.calculator = P.calculator || {};

    P.calculator.recalculate = function () {
      if (getActiveTabId() === 'dimensions') {
        calculateFromDimensions();
      } else {
        submitSquareFootage();
      }
    };

    P.calculator.updateSubmitButtonState = updateSubmitButtonState;
    P.calculator.isValid = updateSubmitButtonState;
  }

  function initAll() {
    document.querySelectorAll('[data-gk-calc]').forEach(initCalc);
  }

  P.util.ready(initAll);
  document.addEventListener('shopify:section:load', initAll);
})(window, document);